import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import type { UpdateCheckResult } from '@/mobile/services/appVersion.service';

type AppUpdateDialogProps = {
  open: boolean;
  result: UpdateCheckResult | null;
  onClose: () => void;
};

export function AppUpdateDialog({ open, result, onClose }: AppUpdateDialogProps) {
  const force = Boolean(result?.forceUpdate);

  const handleUpdate = async () => {
    const url = result?.storeUrl;
    if (url) {
      if (Capacitor.isNativePlatform()) {
        await Browser.open({ url });
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
    if (!force) onClose();
  };

  const handleClose = () => {
    if (force) return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} disableEscapeKeyDown={force}>
      <DialogTitle>{force ? 'Update required' : 'Update available'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {result?.message ||
            `A newer version (${result?.latestVersion || 'latest'}) is available. You are on ${result?.currentVersion || 'current'}.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {!force ? <Button onClick={onClose}>Later</Button> : null}
        {force && Capacitor.isNativePlatform() ? (
          <Button color="inherit" onClick={() => void CapApp.exitApp()}>
            Exit
          </Button>
        ) : null}
        <Button variant="contained" onClick={() => void handleUpdate()} disabled={!result?.storeUrl}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
